// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import SelectorSelectMulti from "components/layout/DropdownSelectors/SelectorSelectMulti";
import { UserpanelRow } from "containers/Userpanel/components/UserpanelRow";

// ** Utils & Helpers
import useSelectorPurpose from "hooks/selectors/useSelectorPurpose";

// #####################################################

const Purpose = ({ onAccept, isBan }) => {
	const { t } = useTranslation(["userpanel"]);

	const userSearchFor = useSelector((state) => state.global.user.searchFor);

	const { items, selected, setSelected, compute } = useSelectorPurpose({
		multiple: true,
		initial: userSearchFor,
	});

	// #####################################################

	return (
		<UserpanelRow>
			<SelectorSelectMulti
				label={t("userpanel:data.purpose")}
				emptyText={t("common:choose")}
				items={items}
				selected={selected}
				onAccept={(value) => {
					// ** A/B TESTS: New Purpose
					setSelected(value);
					const valueFiltered = value?.filter((item) =>
						Number.isInteger(item)
					);
					onAccept(compute.valueToApiParam(valueFiltered));
				}}
				withMobileVersion
				activatorStyleOptions={{
					noPad: true,
					noTopMargin: true,
					flex1: true,
				}}
				isBan={isBan}
			/>
		</UserpanelRow>
	);
};

// #####################################################

export default Purpose;

// #####################################################
